module.exports = __webpack_public_path__ + "images/emoji/fries.4dc4c8cc6893569b585e.png";